/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Contact_Next_1Inputs */

const en_contact_next_1 = /** @type {(inputs: Contact_Next_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We read every message ourselves.`)
};

const lv_contact_next_1 = /** @type {(inputs: Contact_Next_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Katru ziņu izlasām paši.`)
};

/**
* | output |
* | --- |
* | "We read every message ourselves." |
*
* @param {Contact_Next_1Inputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const contact_next_1 = /** @type {((inputs?: Contact_Next_1Inputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Contact_Next_1Inputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_contact_next_1(inputs)
	return en_contact_next_1(inputs)
});